import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid, Box, Typography, Button,
} from '@material-ui/core';
import { withTranslation } from 'config/i18n';

import Link from 'components/shared/Link';

const useStyles = makeStyles((theme) => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 0),
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  vehicleGrid: {
    textAlign: 'center',
  },
  vehiclePhoto: {
    maxWidth: '100%',
    borderRadius: theme.typography.pxToRem(4),
    maxHeight: theme.spacing(10),
    [theme.breakpoints.up('md')]: {
      maxHeight: theme.spacing(15),
    },
  },
  vehicleInfo: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  vehicleTitle: {
    fontSize: theme.typography.pxToRem(18),
  },
  vehiclePrice: {

  },
  link: {
    paddingLeft: 0,
    textDecoration: 'underline',
  },
  location: {
    color: theme.palette.grey[300],
  },
  greenButton: {
    borderColor: theme.palette.success.main,
    color: theme.palette.success.dark,
    '&:hover': {
      borderColor: theme.palette.success.dark,
    },
  },
  editMybike: {
    color: theme.palette.common.white,
  },
}));

const VehicleList = (props) => {
  const classes = useStyles();
  const {
    t, imgUrl, title, price, hourlyPrice, location, listingLink, editLink, onDeactivate, onActivate, state,
  } = props;
  return (
    <div className={classes.root}>
      <Grid container spacing={3}>
        <Grid lg={3} md={4} xs={12} item className={classes.vehicleGrid}>
          <img
            className={classes.vehiclePhoto}
            src={imgUrl || '/imgs/moto-placeholder.png'}
            alt={title}
          />
        </Grid>
        <Grid lg={6} md={8} xs={12} item>
          <Box className={classes.vehicleInfo}>
            {title && (
              <Typography className={classes.vehicleTitle} variant="h4">
                {title}
              </Typography>
            )}
            {price && (
            <Typography className={classes.vehiclePrice} variant="h5">
              {price}
              {' '}
              <small>{t('fe_es_bikes_list:bike_card.per_day')}</small>
            </Typography>
            )}
            {hourlyPrice && (
            <Typography className={classes.vehiclePrice} variant="h5">
              {hourlyPrice}
              {' '}
              <small>{t('fe_es_bikes_list:bike_card.per_hour')}</small>
            </Typography>
            )}
            {location && (
            <Typography className={classes.location}>
              {location}
            </Typography>
            )}

            {(state == 'active' && listingLink)
              && (
              <Button
                variant="text"
                color="secondary"
                className={classes.link}
                component={Link}
                href={listingLink}
              >
                {t('fe_es_bikes_list:bike_card.view_listing')}
              </Button>
              )}
          </Box>

        </Grid>
        <Grid lg={3} md={12} xs={12} item>

          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid lg={12} md={3} xs={6} item>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                component={Link}
                href={editLink}
                className={classes.editMybike}
                disableElevation
              >
                {t('fe_es_bikes_list:bike_card.edit_details')}
              </Button>
            </Grid>

            {state == 'active'
              && (
                <Grid lg={12} md={3} xs={6} item>
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onClick={onDeactivate}
                    disableElevation
                  >
                    {t('fe_es_bikes_list:bike_card.deactivate')}
                  </Button>
                </Grid>
              )}

            {state == 'inactive'
              && (
                <Grid lg={12} md={3} xs={6} item>
                  <Button
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onClick={onActivate}
                    disableElevation
                    classes={{ root: classes.greenButton }}
                  >
                    {t('fe_es_bikes_list:bike_card.activate')}
                  </Button>
                </Grid>
              )}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
export default withTranslation('fe_es_bikes_list')(VehicleList);
